import React from "react";
import { PDF_STATUS } from "../hooks/usePdfUpload";

// Lecture-note PDF input + status line + the required "Ders notları kontrol
// edilmiştir" attestation checkbox. The checkbox is auto-unchecked when the
// PDF is invalidated by a metadata change (see usePdfUpload.invalidate).
const PdfUploadField = ({ pdf, onFileSelected }) => {
    const statusClass =
        pdf.status === PDF_STATUS.Success
            ? "olp-pdf-status--success"
            : pdf.status === PDF_STATUS.Uploading
            ? "olp-pdf-status--pending"
            : "olp-pdf-status--error";

    return (
        <React.Fragment>
            <div className="olp-field">
                <label htmlFor="LectureNoteUrl">Ders notu dosyasını seçiniz(Slayt): </label>
                <input
                    type="file"
                    name="LectureNoteUrl"
                    id="LectureNoteUrl"
                    accept="application/pdf"
                    ref={pdf.fileInputRef}
                    onChange={(e) => {
                        e.preventDefault();
                        const selectedFile = e.target.files[0];
                        if (selectedFile) onFileSelected(selectedFile);
                    }}
                />
            </div>
            <div className={"olp-pdf-status " + statusClass}>{pdf.message}</div>
            <div className="olp-field olp-field--check">
                <input
                    type="checkbox"
                    // required
                    name="LectureNoteUrlCheck"
                    id="LectureNoteUrlCheck"
                    checked={pdf.notesChecked}
                    onChange={(e) => pdf.setNotesChecked(e.target.checked)}
                />
                <label htmlFor="LectureNoteUrlCheck">Ders notları kontrol edilmiştir.</label>
            </div>
        </React.Fragment>
    );
};

export default PdfUploadField;
